import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import {
  Button,
  Form,
  Header,
  Label,
  Segment,
  Select,
} from 'semantic-ui-react';
import { shelfRack, ShelfRackInitialState } from '../../app/models/shelfRack';
import { store, useStore } from '../../app/stores/store';
import { v4 as uuid } from 'uuid';
import { Formik } from 'formik';
import * as Yup from 'yup';
import MyTextInput from '../../app/common/form/MyTextInput';

interface Props {
  viewPort: boolean;
}
function ShelfRackMasterForm({ viewPort = true }: Props) {
  const {
    ShelfRackStore,
    vaultStore,
    modalStore,
    userStore: { user },
    commonStore: { hfcCustomerChanges },
  } = useStore();
  const { selectedshelfRack, updateShelfRack } = ShelfRackStore;
  const { vaultitemsByDate, vaultRegistry, loadVaults } = vaultStore;
  const [vaultName, setVaultName] = useState<string>('');
  const [errorType, setErrorType] = useState<string>(''); //for error text
  const { dashboardStore } = useStore();
  const [isEdit, setIsEdit] = useState(false);
  const [shelfData, setShelfData] = useState<shelfRack>(ShelfRackInitialState);

  useEffect(() => {
    if (vaultRegistry.size <= 1) loadVaults();
  }, [vaultRegistry.size, loadVaults, vaultRegistry]);
  /////////////////////For Updating values
  useEffect(() => {
    // updating
    if (
      selectedshelfRack?.id !== undefined &&
      dashboardStore.dashboard.formikClearFormBool === true
    ) {
      const newArr = {
        ...selectedshelfRack,
      };
      setIsEdit(true);
      setShelfData(newArr);
      setVaultName(newArr.vaultName);
    }
    // eslint-disable-next-line
  }, [selectedshelfRack]);

  const vaultOptions: any = vaultitemsByDate.map((x) => ({
    key: x.id,
    text: x.vaultName,
    value: x.vaultName,
  }));
  ////////////////////////////////////////////   to get vault ands set name
  const getSelectedVault = (e: any, data: any) => {
    setVaultName(data.value);
  };
  ////// /////////////////////////////////////////////  Frrm Submit
  const handleSubmit = (values: shelfRack) => {
    if (values.id === '') {
      if (vaultName === '') {
        setErrorType('Vault Error'); //checking errors
      } else {
        setErrorType('');
      }
      vaultitemsByDate.forEach((vauldata) => {
        if (vaultName === vauldata.vaultName && errorType === '') {
          vauldata.shelfRackItemByVault = [
            {
              id: uuid(),
              shelfNumber: values.shelfNumber,
              rackNumber: values.rackNumber,
              rackType: values.rackType,
              isActiveShelfRack: false,
              vaultName: vaultName,
            },
          ];
          dashboardStore.dashboard.formikClearFormBool = false;
          ShelfRackStore.createShelfRack(vauldata); //create data
          store.ShelfRackStore.selectedshelfRack = undefined;
        }
      });
    } else {
      const updatedShelfData = {
        ...values,
      };
      dashboardStore.dashboard.formikClearFormBool = false; //resetting data
      updateShelfRack(updatedShelfData); //update  data   api
      store.ShelfRackStore.selectedshelfRack = undefined; //resetting data
    }
    modalStore.closeModal(); //closing modal
    setShelfData(ShelfRackInitialState); //resetting data
    setVaultName(''); //resetting data
    setIsEdit(false);
  };

  ////////////////////handle Change
  const handleChange = (e: any, data?: any) => {
    if (data !== undefined) {
      const newArr = {
        ...shelfData,
        [data.name]: data.value,
      };
      setShelfData(newArr);
    } else {
      const newArr = {
        ...shelfData,
        [e.target.name]: e.target.value,
      };
      setShelfData(newArr);
    }
  };

  ////////////////////handle Cancel
  const handleCancel = () => {
    setShelfData(ShelfRackInitialState); //resetting data
    modalStore.closeModal(); //closing modal
    setVaultName(''); //resetting data
    dashboardStore.dashboard.formikClearFormBool = false; //resetting data
    store.ShelfRackStore.selectedshelfRack = undefined; //resetting data
    setIsEdit(false);
  };

  return (
    <div id={viewPort ? 'parent-grid-shelf' : ''}>
      <Segment clearing className="shelf-form-segment" responsive={true}>
        <Header
          icon="edit"
          size="huge"
          dividing
          as="h1"
          content= {hfcCustomerChanges? "Room/Shelf Master" :"Shelf/Rack Master"}
          sub
          color="grey"
        />
        <Formik
          initialValues={shelfData}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            handleSubmit(values);
            resetForm();
          }}
          validationSchema={Yup.object({
            rackType: Yup.string()
                  .min(1, 'Please enter a Rack Type')
                  .max(150, 'Too Long, it should be upto 150 characters!')
                  .required('Please enter a Rack Type'),
            shelfNumber: !hfcCustomerChanges  ? Yup.string()
            .min(1, 'Please enter a Aisle Number')
            .max(150, 'Too Long, it should be upto 150 characters!') 
            .required('Please enter a Aisle Number')
            : Yup.string()
              .min(1, 'Please enter a Shelf Number')
              .max(150, 'Too Long, it should be upto 150 characters!')
              .required('Please enter a Shelf Number'), //.matches(/^\S*$/, 'Whitespace is not allowed'),
            rackNumber: Yup.string()
              .min(1, 'Please enter a Rack Number')
              .max(150, 'Too Long, it should be upto 150 characters!')
              .required(hfcCustomerChanges? 'Please enter a Rack Number':'Please enter a Rack Number'), //.matches(/^\S*$/, 'Whitespace is not allowed')
          })}
        >
          {({ handleSubmit }) => (
            <Form className="ui form error" autoComplete="off">
              <Form.Group widths="equal">
                <Form.Field
                  control={Select}
                  options={vaultOptions}
                  label={
                    user?.customerName === 'LVP CMS - AM' ? 'Room' : 'Vault'
                  }
                  name="vaultName"
                  placeholder={
                    user?.customerName === 'LVP CMS - AM' ? 'Room' : 'Vault'
                  }
                  value={vaultName}
                  style={{
                    pointerEvents: isEdit ? 'auto' : 'auto',
                    opacity: isEdit ? '0.9' : '1',
                  }}
                  onChange={(e: any, data: any) => {
                    getSelectedVault(e, data);
                    handleChange(e, data);
                  }}
                />
                {/* <label style={{ marginBottom: "5px", color: "black" }}> Vault </label> */}
                {/* <Dropdown
                        placeholder="Vault"
                        name="vaultName"
                        label="Vault"
                        fluid
                        clearable
                        selection
                        options={vaultOptions}
                        value={vaultName}
                        onChange={(e: any, data) => getSelectedVault(e, data)}
                      /> */}
                {errorType === 'Vault Error' && (
                  <Label basic color="red" style={{ marginTop: '2px' }}>
                    Please Select a Vault
                  </Label>
                )}
                {
                  hfcCustomerChanges ?(
                    <MyTextInput
                  label={hfcCustomerChanges ? "Room" : "Rack Number"}
                  name="rackNumber"
                  type="text"
                  value={shelfData.rackNumber}
                  onChange={(e: any) => handleChange(e)}
                  placeholder="Enter Rack Number"
                />
                  ):(
                    <MyTextInput
                    label="Shelf Number"
                    name="shelfNumber"
                    type="text"
                    value={shelfData.shelfNumber}
                    onChange={(e: any) => handleChange(e)}
                    placeholder="Enter Shelf Number"
                  />
                  )
                }
              </Form.Group>
              <Form.Group widths="equal">
                {
                  hfcCustomerChanges ? 
                  <MyTextInput
                  label={hfcCustomerChanges ? "Asile Number" : "Rack Type"}
                  name="rackType"
                  type="text"
                  value={shelfData.rackType}
                  onChange={(e: any) => handleChange(e)}
                  placeholder="Enter Asile Number"
                /> :
                <MyTextInput
                  label={hfcCustomerChanges ? "Room" : "Rack Number"}
                  name="rackNumber"
                  type="text"
                  value={shelfData.rackNumber}
                  onChange={(e: any) => handleChange(e)}
                  placeholder="Enter Rack Number"
                />
                }
                {
                  !hfcCustomerChanges ?
                 <MyTextInput
                  label={"Aisle Number"}
                  name="aisleNumber"
                  type="text"
                  value={shelfData.aisleNumber}
                  onChange={(e: any) => handleChange(e)}
                  placeholder="Enter Asile Number"
                />:
                <MyTextInput
                    label={hfcCustomerChanges ? "Shelf" : "Shelf Number"}
                    name="shelfNumber"
                    type="text"
                    value={shelfData.shelfNumber}
                    onChange={(e: any) => handleChange(e)}
                    placeholder="Enter Shelf Number"
                  />
              }
                {!hfcCustomerChanges && (
                  <MyTextInput
                    label={'Rack Type'}
                    name="rackType"
                    value={shelfData.rackType}
                    type="text"
                    onChange={(e: any) => handleChange(e)}
                    placeholder={'Enter Rack Type'}
                  />
                )}
              </Form.Group>
              <Button.Group floated="right" style={{ marginTop: '20px' }}>
                <Button type="reset" onClick={handleCancel}>
                  Cancel{' '}
                </Button>
                <Button.Or />
                <Button
                  // disabled={isSubmitting || !dirty}
                  onClick={() => handleSubmit()}
                  type="submit"
                  content="Submit"
                  positive
                >
                  Save
                </Button>
              </Button.Group>
            </Form>
          )}
        </Formik>
      </Segment>
    </div>
  );
}
export default observer(ShelfRackMasterForm);
